import {combineReducers} from 'redux';

import {alertsData} from '../views/controllers/alerts/services/reducers/alertsData';
import {limits} from '../views/controllers/limits/services/reducers';
import {contractsData} from '../views/controllers/pricing/services/reducers/contractsData';
import {packagesData} from '../views/controllers/pricing/services/reducers/packagesData';
import {releaseNotes} from '../views/controllers/release-notes/services/reducers';
import {ranges} from '../views/controllers/setup/services/reducers/ranges';
import {setupData} from '../views/controllers/setup/services/reducers/setupData';


import {accountId} from './account-id/reducers';

import type {State as AccountIdState} from './account-id/reducers';
import type {State as AlertsDataState} from '../views/controllers/alerts/services/reducers/alertsData';
import type {State as LimitsState} from '../views/controllers/limits/services/reducers';
import type {State as ContractsDataState} from '../views/controllers/pricing/services/reducers/contractsData';
import type {State as PackagesDataState} from '../views/controllers/pricing/services/reducers/packagesData';
import type {State as ReleaseNotesState} from '../views/controllers/release-notes/services/reducers';
import type {State as RangesState} from '../views/controllers/setup/services/reducers/ranges';
import type {State as SetupDataState} from '../views/controllers/setup/services/reducers/setupData';


export type State = {
    setupData: SetupDataState,
    ranges: RangesState,
    limits: LimitsState,
    releaseNotes: ReleaseNotesState,
    packagesData: PackagesDataState,
    contractsData: ContractsDataState,
    alertsData: AlertsDataState,
    accountId: AccountIdState,
};

export const rootReducer = combineReducers({
    setupData,
    ranges,
    limits,
    releaseNotes,
    packagesData,
    contractsData,
    alertsData,
    accountId,
});
